import { render, staticRenderFns } from "./TraplinkedNotification.vue?vue&type=template&id=e56a50c8"
import script from "./TraplinkedNotification.vue?vue&type=script&lang=js"
export * from "./TraplinkedNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports